import React, { useContext, useEffect, useState } from 'react'
import {
  Tooltip,
  Avatar,
  Dropdown,
  Menu,
  Divider,
  Button,
} from '@arco-design/web-react'
import { useSelector, useDispatch } from 'react-redux'
import { GlobalContext } from '@/context'
import useLocale from '@/hooks/useLocale'
import logoPath from '@/assets/logo.png'
import Settings from '../Settings'
import styles from './style/index.module.less'
import useStorage from '@/hooks/useStorage'
import { generatePermission } from '@/routes'
import { updateUserInfo } from '@/store/slices/appSlice'
import IconButton from './IconButton'
import {
  IconLoading,
  IconLanguage,
  IconMoonFill,
  IconPoweroff,
  IconSettings,
  IconSunFill,
  IconUser,
  IconLock,
} from '@arco-design/web-react/icon'
import { EditPasswordForm } from './EditPasswordForm'
import { getCurrentUser } from '@/store/slices/userSlice'
import { getSetting } from '@/utils/settings'
const KEY_TOKEN_LOGIN = getSetting('KEY_TOKEN_LOGIN')
const KEY_USER_INFO = getSetting('KEY_USER_INFO')

function Navbar({ show }) {
  const t = useLocale()
  const currentUser = useSelector(getCurrentUser)
  const { userInfo, userLoading } = useSelector((state) => state['app'])
  const dispatch = useDispatch()
  const [formEvent, setFormEvent] = useState(null)
  const [role, setRole] = useStorage('userRole', 'admin')

  const [__userInfo, setUserInfo, removeUserInfo] = useStorage(KEY_USER_INFO)
  const [token, setToken, removeToken] = useStorage(KEY_TOKEN_LOGIN)
  const [editPasswordVisible, setEditPasswordVisible] = useState(false)
  const { setLang, lang, theme, setTheme } = useContext(GlobalContext)

  function logout() {
    removeUserInfo()
    removeToken()
    window.location.reload()
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout()
    } else if (key == 'editPassword') {
      setEditPasswordVisible(true)
      setFormEvent({
        name: 'showAndSwitchTab',
        params: ['0'],
      })
    }
  }
  function onLangMenuClick(key) {
    if (key === 'zh-CN' || key === 'en-US') {
      setLang(key)
    }
  }

  useEffect(() => {
    dispatch(
      updateUserInfo({
        ...userInfo,
        permissions: generatePermission(role),
      })
    )
  }, [role])
  const onSubmit = () => {
    setFormEvent(null)
  }
  const onCancel = () => {
    setFormEvent(null)
  }
  if (!show) {
    return (
      <div className={styles['fixed-settings']}>
        <Settings
          trigger={
            <Button icon={<IconSettings />} type="primary" size="large" />
          }
        />
      </div>
    )
  }
  const droplist = (
    <Menu onClickMenuItem={onMenuItemClick}>
      <Menu.Item key="setting">
        <IconUser className={styles['dropdown-icon']} />
        {currentUser?.name}
      </Menu.Item>
      <Menu.Item key="editPassword">
        <IconLock className={styles['dropdown-icon']} />
        {t['user.editPassword']}
      </Menu.Item>
      <Divider style={{ margin: '4px 0' }} />
      <Menu.Item key="logout">
        <IconPoweroff className={styles['dropdown-icon']} />
        {t['navbar.logout']}
      </Menu.Item>
    </Menu>
  )
  const langDroplist = (
    <Menu onClickMenuItem={onLangMenuClick} selectedKeys={[lang]}>
      <Menu.Item key="zh-CN">中文</Menu.Item>
      <Menu.Item key="en-US">English</Menu.Item>
    </Menu>
  )

  return (
    <div className={styles.navbar}>
      <div className={styles.left}>
        <div className={styles.logo}>
          <img src={logoPath} style={{ height: '48px' }} />
        </div>
      </div>
      <ul className={styles.right}>
        <li>
          <Tooltip content={t['language']}>
            <Dropdown droplist={langDroplist} position="br">
              <span>
                <IconButton icon={<IconLanguage />} />
              </span>
            </Dropdown>
          </Tooltip>
        </li>
        <li>
          <Tooltip
            content={
              theme === 'light'
                ? t['settings.navbar.theme.toDark']
                : t['settings.navbar.theme.toLight']
            }
          >
            <IconButton
              icon={theme !== 'dark' ? <IconMoonFill /> : <IconSunFill />}
              onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
            />
          </Tooltip>
        </li>
        <Settings />
        {userInfo && (
          <li>
            <Dropdown droplist={droplist} position="br" disabled={userLoading}>
              <Avatar size={32} style={{ cursor: 'pointer' }}>
                {userLoading ? <IconLoading /> : <IconUser />}
              </Avatar>
            </Dropdown>
          </li>
        )}
      </ul>
      <div
        style={{
          display: 'none',
        }}
      >
        <EditPasswordForm
          formData={{}}
          event={formEvent}
          disabled={false}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    </div>
  )
}

export default Navbar

